<div class="layoutBlock">
    <div class="fullWidth">
        <p-panel header="{{'rm.erp.jobapplication.overview.panel.data.title' | hisUi }}">

            <div class="detailPresentationList">
                <ng-container *ngFor="let field of fields">
                    <erp-jobapplication-field [field]="field" [jobApplication]="jobApplication.application"
                        [readonly]="true">
                    </erp-jobapplication-field>
                </ng-container>
            </div>

            <div *ngIf="jobApplication.documents.length > 0" class="clearerSpaceAbove1Em">
                <p-table [value]="jobApplication.documents" [paginator]="false" [responsive]="true">
                    <ng-template pTemplate="caption">
                        {{'rm.erp.jobapplication.overview.table.documents.title' | hisUi}}
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th>{{'rm.erp.common.documents.upload.filecategory' | hisUi}}</th>
                            <th>{{'rm.erp.common.documents.upload.filename' | hisUi}}</th>
                            <th>{{'rm.erp.common.documents.upload.filesize' | hisUi}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-index="rowIndex" let-document>
                        <tr>
                            <td>{{ document.documentCategory?.longtext }}</td>
                            <td>{{ document.filename }}</td>
                            <td>{{ document.filesize }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </p-panel>

        <div class="clearAndSpace"></div>

        <p-panel header="{{'rm.erp.jobapplication.overview.panel.privacypolicy.title' | hisUi }}">

            <div>
                <button type="text" (click)="displayPrivacyPolicy=true" hisImage="INFORMATION"
                    class="transparent">{{'rm.erp.jobapplication.JobApplication.privacypolicy' | hisUi}}</button>
            </div>

            <div>
                <input type="checkbox" id="privacypolicy" class="checkboxBeforeLabel"
                    [(ngModel)]="jobApplication.privacyPolicyAccepted">
                <label for="privacypolicy">{{'rm.erp.jobapplication.JobApplication.acceptprivacypolicy' |
                    hisUi}}</label>
            </div>
        </p-panel>
    </div>
</div>

<p-dialog [(visible)]="displayPrivacyPolicy" [responsive]="true" [maximizable]="true" [modal]="true"
    [dismissableMask]="true" [blockScroll]="true">
    <p-header>
        <h2>{{'rm.erp.jobapplication.JobApplication.privacypolicy' | hisUi}}</h2>
    </p-header>
    <iframe frameborder="0" [src]="privacyPolicyUrl" scrolling="auto" width="750" height="500" marginheight="5"
        marginwidth="10"></iframe>
</p-dialog>

<div class="clearAndSpace"></div>

<div class="layoutBlock">
    <button (click)="backToJobApplicationForm()">
        {{'rm.erp.jobapplication.button.backToJobApplicationForm'| hisUi }}
    </button>

    <button (click)="createJobApplication($event)" hisImage="ARROW_RIGHT_FAT" class="button_highlighted_dark_green">
        {{'rm.erp.jobapplication.button.saveApplication'| hisUi }}
    </button>
</div>
